import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "disabled", "isLocked", "onClick", "tooltip"];
import { Button, ButtonIconBreeze, ButtonIconBreezeTooltip } from 'breeze-intelligence-kit';
import { LockBadge } from 'breeze-intelligence-kit';
import { CreditUpgradeTooltip } from '../ModalBulk/CreditUpgradeTooltip';
import { useEnrichmentCredits } from '../EnrichmentCreditsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EnrichmentActionButton(_ref) {
  let {
      children,
      disabled,
      isLocked,
      onClick,
      tooltip = /*#__PURE__*/_jsx(CreditUpgradeTooltip, {})
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isIncludedEnrichment
  } = useEnrichmentCredits();
  const isDisabled = disabled || isLocked;
  if (isLocked) {
    return /*#__PURE__*/_jsxs(ButtonIconBreezeTooltip, Object.assign({}, rest, {
      disabled: true,
      tooltip: tooltip,
      width: 300,
      children: [children, /*#__PURE__*/_jsx(LockBadge, {})]
    }));
  }
  if (isIncludedEnrichment) {
    return /*#__PURE__*/_jsx(Button, {
      disabled: isDisabled,
      onClick: onClick,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(ButtonIconBreeze, Object.assign({}, rest, {
    disabled: isDisabled,
    onClick: onClick,
    children: children
  }));
}